import React from "react";

// eslint-disable-next-line react/prop-types
function GlowingWaldo({ classList, w, h }) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={`${w}px`}
      height={`${h}px`}
      viewBox="0 0 300 300"
      preserveAspectRatio="xMidYMid meet"
      className={classList}
    >
      <metadata>
        Created by potrace 1.10, written by Peter Selinger 2001-2011
      </metadata>
      <g
        transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)"
        fill="goldenrod"
        stroke="none"
      >
        <path
          d="M774 2876 c-6 -16 3 -83 13 -99 3 -5 11 0 18 10 13 17 14 17 20 1 4
        -10 11 -18 15 -18 9 0 40 62 40 79 0 19 -29 12 -40 -10 -15 -28 -35 -19 -35
        16 0 31 -22 46 -31 21z"
        />
        <path
          d="M918 2819 c-29 -14 -38 -25 -38 -44 0 -29 12 -32 34 -9 9 9 29 19 44
        23 17 5 27 14 27 27 0 25 -22 26 -67 3z"
        />
        <path
          d="M729 2818 c-1 -1 -3 -13 -4 -26 -2 -16 2 -22 14 -20 19 4 22 39 4 46
        -7 2 -14 2 -14 0z"
        />
        <path
          d="M649 2784 c-11 -14 -10 -18 6 -31 12 -8 19 -23 17 -35 -3 -16 0 -19
        13 -14 9 3 25 6 36 6 27 0 24 11 -14 53 -37 42 -40 43 -58 21z"
        />
        <path
          d="M1375 2724 c-42 -22 -58 -25 -103 -20 -29 4 -61 2 -71 -3 -12 -7 -31
        -7 -56 0 -30 8 -46 7 -74 -5 -52 -22 -101 -30 -101 -17 0 7 11 16 25 21 23 9
        36 40 16 40 -16 0 -81 -30 -81 -38 0 -4 5 -13 12 -20 15 -15 7 -23 -57 -57
        -27 -14 -59 -34 -70 -45 -23 -21 -54 -28 -72 -17 -7 5 -25 -4 -45 -22 -29 -26
        -31 -31 -18 -46 13 -16 16 -15 43 16 26 31 28 31 21 9 -4 -14 -8 -43 -9 -65 0
        -22 -6 -50 -13 -62 -7 -12 -14 -54 -17 -92 -2 -38 -8 -79 -14 -90 -18 -33 -12
        -84 17 -141 26 -53 33 -58 100 -76 6 -2 12 -14 12 -27 0 -14 7 -30 15 -37 21
        -18 19 -47 -5 -53 -24 -6 -52 -68 -44 -94 14 -44 31 -67 70 -94 36 -24 44 -37
        58 -91 19 -72 25 -102 30 -140 5 -46 34 -69 80 -66 34 3 41 0 43 -17 5 -33 34
        -139 43 -155 4 -9 11 -31 15 -50 11 -49 72 -171 101 -203 14 -15 31 -27 39
        -27 8 0 15 -8 16 -17 0 -10 2 -53 5 -95 4 -84 5 -83 -62 -93 -60 -10 -90 -18
        -109 -31 -11 -8 -28 -14 -37 -14 -10 0 -27 -4 -38 -10 -49 -24 -58 -28 -90
        -35 -19 -4 -64 -20 -99 -36 -35 -16 -68 -29 -73 -29 -6 0 -29 -13 -53 -29 -24
        -16 -53 -32 -64 -36 -12 -3 -21 -11 -21 -16 0 -5 -8 -9 -18 -9 -11 0 -29 -9
        -42 -20 -13 -11 -27 -20 -32 -20 -8 0 -49 -37 -108 -95 -27 -27 -58 -74 -75
        -115 -10 -25 -25 -52 -32 -61 -7 -8 -13 -19 -13 -22 0 -9 -36 -92 -56 -129
        -14 -26 -14 -28 5 -28 21 0 51 34 51 58 0 7 24 61 52 119 41 80 69 121 120
        174 37 38 74 69 82 69 7 0 19 7 26 15 7 8 21 15 31 15 10 0 22 6 26 13 12 19
        110 68 125 62 13 -5 327 -15 437 -14 30 0 62 4 70 9 9 4 22 5 31 0 18 -10 325
        -8 335 2 4 4 15 3 25 -2 9 -5 41 -9 71 -9 113 -1 425 9 437 14 13 5 107 -40
        130 -62 7 -7 19 -13 26 -13 8 0 19 -7 26 -15 7 -8 19 -15 27 -15 8 0 44 -31
        81 -68 53 -55 79 -92 125 -185 31 -64 57 -122 57 -129 0 -20 21 -38 43 -38 17
        0 17 2 3 28 -8 15 -24 50 -35 77 -12 28 -26 57 -31 65 -5 8 -18 35 -30 60 -11
        25 -24 52 -30 60 -6 8 -18 27 -28 43 -9 15 -25 30 -34 33 -10 3 -18 11 -18 19
        0 8 -9 17 -20 20 -11 3 -25 15 -30 26 -6 10 -17 19 -25 19 -9 0 -23 9 -32 20
        -10 11 -28 20 -40 20 -13 0 -23 4 -23 9 0 5 -9 13 -21 16 -11 4 -40 20 -64 36
        -24 16 -47 29 -53 29 -5 0 -35 12 -66 26 -31 14 -62 27 -69 28 -32 6 -89 27
        -129 47 -10 5 -25 9 -34 9 -9 0 -28 6 -42 14 -36 18 -87 33 -142 40 l-45 6 1
        58 c4 133 3 128 29 140 24 11 95 135 95 167 0 8 4 23 9 33 6 9 17 44 26 77 10
        33 22 72 27 87 5 15 7 32 3 38 -4 6 -2 24 5 40 11 26 14 28 36 18 51 -24 98
        29 95 105 -1 22 2 44 7 50 6 7 13 36 17 66 6 45 15 62 56 107 38 42 49 62 49
        87 0 37 -24 77 -46 77 -17 0 -17 4 -2 47 14 39 27 41 56 8 19 -22 28 -24 84
        -21 52 3 66 8 85 31 31 36 29 52 -7 53 -16 0 -37 5 -47 11 -17 9 -17 10 2 17
        31 12 75 47 75 60 0 6 -18 14 -40 18 -40 6 -56 26 -22 26 24 0 96 50 85 60 -4
        5 -26 10 -47 12 -49 4 -54 17 -17 43 25 16 51 53 51 70 0 3 -21 2 -47 -1 l-48
        -7 38 36 c35 33 45 56 31 70 -4 3 -16 2 -26 -4 -16 -8 -30 -7 -59 7 -22 9 -42
        14 -45 11 -4 -4 -19 2 -34 13 -16 11 -38 20 -49 20 -12 0 -33 7 -46 16 -16 11
        -36 14 -55 11 -16 -4 -32 -2 -36 4 -3 6 -25 9 -47 7 -41 -3 -42 -2 -44 28 -1
        23 -16 47 -61 93 -52 54 -64 61 -93 60 -19 -2 -44 3 -56 10 -37 19 -130 33
        -150 22 -13 -6 -26 -5 -43 5 -32 17 -27 18 -85 -12z m81 -25 c4 -7 23 -9 48
        -5 22 3 59 2 81 -2 l40 -8 -33 -17 c-18 -10 -36 -15 -41 -13 -5 3 -20 -3 -34
        -14 -17 -13 -40 -20 -70 -20 -27 0 -49 -6 -57 -15 -7 -8 -23 -15 -36 -15 -13
        0 -24 -4 -24 -9 0 -10 -55 -41 -74 -41 -6 0 -29 -14 -50 -30 -22 -17 -49 -30
        -61 -30 -12 0 -33 -8 -46 -18 -13 -11 -46 -31 -74 -46 -27 -16 -59 -36 -71
        -47 -11 -10 -29 -19 -40 -19 -11 0 -31 -11 -43 -24 -12 -13 -37 -27 -54 -31
        -42 -10 -49 -12 -69 -20 -20 -8 -26 19 -8 30 6 4 8 15 5 25 -9 27 12 60 37 60
        11 0 37 10 57 23 19 12 45 27 56 32 25 13 34 65 10 65 -11 0 -15 -7 -13 -22 2
        -11 -2 -23 -9 -25 -7 -2 -13 8 -15 24 -4 32 -23 29 -23 -4 -1 -13 -6 -28 -13
        -35 -9 -9 -12 -6 -12 15 0 15 -4 27 -10 27 -10 0 -14 -19 -11 -52 3 -24 -16
        -23 -28 1 -15 27 5 91 28 91 10 0 28 11 41 25 13 14 28 25 33 25 5 0 21 8 35
        18 30 21 120 52 149 52 11 0 24 5 30 11 8 8 25 8 56 1 25 -5 51 -6 58 -2 6 5
        43 8 80 8 52 -1 75 4 101 20 37 24 63 28 74 11z m319 -85 c25 -25 45 -50 45
        -55 0 -4 -17 -13 -39 -19 -21 -5 -44 -17 -51 -25 -7 -8 -25 -15 -41 -15 -15 0
        -45 -11 -65 -25 -20 -14 -49 -25 -64 -25 -15 0 -38 -8 -51 -18 -13 -11 -39
        -24 -57 -30 -18 -6 -45 -20 -59 -32 -14 -11 -36 -20 -49 -20 -12 0 -51 -19
        -86 -43 -35 -23 -85 -52 -113 -65 -27 -13 -57 -28 -65 -33 -8 -5 -29 -16 -46
        -24 -17 -8 -45 -30 -62 -50 -18 -19 -64 -52 -103 -71 -82 -42 -112 -38 -124
        15 -4 17 -11 33 -16 36 -5 4 -9 24 -9 46 0 36 4 41 33 54 18 7 41 23 51 34 11
        12 27 21 37 21 10 0 31 11 47 25 17 14 39 25 49 25 11 0 28 9 37 19 10 11 42
        31 71 45 29 15 58 33 65 41 7 8 22 15 34 15 11 0 41 14 66 30 25 16 49 30 54
        30 5 0 31 14 58 30 26 17 54 30 62 30 7 0 19 7 26 15 8 9 22 12 40 8 18 -3 42
        2 67 15 70 37 138 60 176 61 32 1 44 -6 82 -45z m63 -120 c15 -10 52 -17 103
        -20 49 -2 89 -10 102 -19 12 -8 33 -15 48 -15 15 0 32 -7 39 -15 7 -8 22 -15
        34 -15 11 0 38 -6 60 -14 l38 -13 -23 -17 c-13 -9 -30 -16 -39 -16 -19 0 -108
        31 -130 45 -8 5 -19 10 -25 10 -5 1 -23 7 -39 14 -21 8 -54 10 -106 5 -80 -7
        -119 4 -150 41 -12 15 -12 19 5 31 25 18 55 18 83 -2z m-90 -56 c33 -33 33
        -33 140 -33 59 -1 116 -6 127 -12 34 -18 145 -61 218 -83 37 -12 38 -12 20
        -32 -18 -20 -23 -20 -111 -2 -19 3 -36 13 -39 20 -3 8 -15 14 -28 14 -12 0
        -28 7 -35 15 -7 8 -23 15 -36 15 -12 0 -25 4 -29 9 -3 5 -31 7 -63 5 -31 -3
        -85 -6 -119 -7 -63 -2 -63 -2 -110 46 -46 46 -47 49 -29 63 31 22 57 17 94
        -18z m-87 -53 c13 -19 38 -41 54 -49 38 -18 123 -23 150 -9 11 6 32 10 47 8
        70 -8 108 -18 119 -31 6 -8 19 -14 29 -14 10 0 23 -7 30 -15 7 -8 19 -15 27
        -15 8 0 48 -17 90 -37 l76 -37 -29 -13 c-46 -19 -73 -15 -114 17 -21 17 -43
        30 -50 30 -7 0 -24 6 -38 14 -70 36 -119 39 -247 18 -63 -10 -146 2 -157 22
        -5 9 -15 16 -22 16 -8 0 -16 7 -20 15 -3 8 -12 15 -21 15 -8 0 -15 6 -15 14 0
        7 -11 21 -25 30 -49 32 -29 53 51 55 37 1 44 -3 65 -34z m-127 -48 c94 -99
        164 -125 281 -105 98 17 204 9 226 -18 6 -8 19 -14 28 -14 9 0 22 -5 28 -11
        13 -13 37 -27 111 -64 29 -14 52 -32 49 -38 -9 -30 -110 -12 -143 25 -10 10
        -23 18 -29 18 -7 0 -18 6 -24 14 -14 16 -65 29 -104 26 -15 -1 -34 4 -42 10
        -11 9 -23 9 -49 0 -70 -23 -168 -35 -262 -31 -17 0 -41 10 -54 21 -13 11 -29
        20 -37 20 -7 0 -13 6 -13 14 0 8 -11 24 -25 35 -15 11 -37 36 -51 56 -32 48
        -18 66 65 84 2 1 23 -18 45 -42z m-135 -43 c12 -15 21 -33 21 -40 0 -7 9 -16
        20 -19 11 -4 27 -20 35 -36 9 -16 20 -29 26 -29 5 0 22 -9 37 -20 23 -17 43
        -21 113 -21 106 0 112 0 179 18 30 8 60 14 65 14 62 -7 102 -15 112 -23 7 -5
        17 -7 23 -3 5 3 10 2 10 -4 0 -6 11 -13 25 -17 14 -3 25 -10 25 -16 0 -5 24
        -20 53 -34 67 -32 128 -75 121 -85 -9 -15 -104 -11 -110 5 -3 8 -20 20 -37 27
        -18 6 -54 25 -80 42 -48 30 -49 30 -154 23 -58 -3 -112 -11 -119 -17 -19 -16
        -289 -25 -298 -10 -4 6 -20 11 -36 11 -24 0 -30 6 -40 34 -6 19 -18 37 -26 40
        -8 3 -19 18 -25 33 -5 16 -24 37 -42 48 -41 26 -48 62 -13 71 14 3 30 12 37
        20 18 22 56 16 78 -12z m-148 -83 c12 -16 30 -32 40 -34 12 -3 19 -14 19 -30
        0 -15 9 -31 25 -41 14 -9 25 -25 25 -35 0 -25 28 -47 70 -56 52 -11 243 -12
        257 -2 7 5 23 7 34 4 12 -3 35 1 50 9 41 21 58 17 69 -13 6 -16 15 -36 20 -45
        6 -10 10 -22 10 -28 0 -5 14 -32 30 -58 35 -58 36 -62 10 -62 -13 0 -25 11
        -34 34 -39 94 -152 141 -258 109 -36 -11 -102 -74 -118 -112 -10 -25 -18 -31
        -44 -31 -27 0 -34 5 -44 34 -23 63 -126 121 -199 113 -42 -4 -44 -3 -38 17 20
        65 27 108 26 170 -1 95 11 109 50 57z m-85 -82 c-2 -39 -6 -72 -8 -75 -6 -5
        -64 79 -72 104 -5 16 0 22 31 35 21 8 41 13 45 11 4 -3 6 -36 4 -75z m-109 -2
        c-4 -12 -7 -55 -8 -95 -2 -81 -19 -97 -39 -36 -7 19 -18 38 -26 41 -24 9 -16
        45 18 80 38 39 63 44 55 10z m66 -109 c15 -34 26 -62 24 -64 -1 -1 -19 -11
        -40 -23 l-39 -22 8 43 c5 24 8 62 7 86 -1 23 1 42 6 42 4 0 20 -28 34 -62z
        m-182 10 c2 -62 5 -93 13 -143 l8 -50 -38 40 c-64 67 -97 142 -66 151 9 3 28
        12 42 19 36 21 40 19 41 -17z m989 -35 c7 -32 16 -65 20 -73 4 -8 4 -24 0 -34
        -7 -20 -9 -17 -63 107 -19 42 -16 57 12 57 14 0 21 -14 31 -57z m57 49 c9 -6
        11 -29 5 -87 -8 -90 -23 -98 -29 -16 -2 30 -8 62 -13 72 -6 10 -10 22 -10 28
        0 13 29 14 47 3z m58 -32 c7 -11 -13 -89 -27 -104 -9 -12 -11 38 -2 83 7 31
        18 39 29 21z m-1055 -48 c0 -5 14 -23 31 -40 31 -31 31 -32 16 -69 -8 -20 -19
        -39 -25 -41 -5 -1 -15 26 -21 62 -6 36 -14 73 -17 81 -4 8 -1 15 5 15 6 0 11
        -4 11 -8z m757 -42 c67 -25 113 -110 99 -181 -12 -64 -89 -129 -152 -129 -34
        0 -105 42 -131 79 -38 50 -35 132 5 179 44 51 120 73 179 52z m-447 -22 c48
        -33 69 -67 74 -120 9 -92 -55 -168 -142 -168 -92 0 -162 74 -162 172 0 99 147
        172 230 116z m780 -43 c16 -19 6 -57 -24 -92 -30 -35 -43 -25 -21 17 18 35 13
        50 -12 34 -22 -14 -43 -77 -48 -144 -8 -97 -22 -208 -29 -219 -10 -15 -41 -14
        -55 2 -6 8 -9 27 -7 43 9 59 68 269 87 305 31 61 82 87 109 54z m-1153 -38
        c12 -12 24 -33 26 -47 3 -14 14 -53 26 -87 12 -34 21 -71 21 -82 0 -10 7 -32
        15 -47 8 -16 15 -39 15 -52 0 -13 5 -32 10 -42 8 -15 6 -21 -11 -31 -31 -16
        -44 3 -58 88 -7 40 -17 75 -22 79 -5 3 -9 20 -9 37 -1 18 -9 61 -18 97 -13 47
        -23 66 -36 68 -15 3 -18 0 -12 -19 21 -77 21 -73 -7 -55 -36 24 -53 70 -38
        103 10 22 16 25 44 19 18 -4 42 -17 54 -29z m989 -64 c-3 -10 -10 -38 -16 -63
        -6 -25 -18 -63 -26 -85 -9 -22 -22 -76 -30 -120 -33 -183 -53 -264 -80 -336
        -44 -120 -66 -159 -95 -174 -34 -18 -200 -29 -302 -20 -79 7 -84 9 -119 47
        -21 21 -38 44 -38 51 0 7 -8 28 -19 47 -10 19 -22 51 -26 70 -4 19 -11 40 -16
        46 -8 10 -53 173 -79 284 -5 19 -15 53 -24 75 -8 22 -15 48 -16 58 0 10 -6 30
        -14 45 -23 46 -28 82 -12 82 15 0 26 -21 26 -49 0 -30 65 -102 114 -127 49
        -25 116 -31 158 -15 57 22 118 113 118 176 0 10 10 15 35 15 28 0 35 -4 35
        -20 0 -78 110 -170 204 -170 24 0 64 9 88 19 56 25 81 62 114 169 2 6 8 12 14
        12 6 0 9 -8 6 -17z m-491 -847 c92 -21 173 -54 193 -79 15 -17 22 -71 12 -87
        -10 -17 -107 -23 -217 -15 l-92 7 -3 95 c-2 52 -1 97 2 99 2 3 14 2 25 -1 11
        -3 47 -12 80 -19z m199 6 c2 -4 1 -14 -3 -21 -7 -10 -12 -10 -30 0 -11 8 -21
        17 -21 21 0 11 47 10 54 0z m-307 -203 c16 -16 270 -19 308 -4 17 6 41 11 55
        10 53 -5 146 -29 161 -41 8 -8 25 -14 37 -14 11 0 24 -4 27 -10 3 -6 16 -10
        29 -10 12 0 26 -4 32 -8 5 -5 29 -15 54 -22 46 -14 160 -67 160 -74 0 -3 -15
        0 -32 5 -18 5 -100 9 -183 8 -82 0 -363 0 -624 0 -261 0 -492 -4 -514 -8 -22
        -5 -35 -6 -31 -1 16 15 111 60 128 60 9 0 25 5 36 10 11 6 29 15 40 20 11 6
        29 10 39 10 11 0 23 5 26 10 3 6 17 10 29 10 13 0 29 7 36 15 7 9 20 13 28 10
        7 -3 19 -2 25 2 14 9 84 30 108 32 8 0 20 -4 26 -10z"
        />
        <path
          d="M1672 1808 c-28 -28 -1 -75 38 -63 14 4 20 15 20 35 0 36 -33 53 -58
        28z"
        />
        <path
          d="M1190 1791 c-5 -11 -7 -26 -4 -34 12 -33 74 -24 74 11 0 41 -51 57
        -70 23z"
        />
        <path
          d="M1344 1529 c-26 -42 174 -68 222 -28 25 20 1 32 -42 20 -38 -10 -116
        -3 -155 13 -10 4 -20 2 -25 -5z"
        />
        <path
          d="M1713 1501 c3 -15 -4 -26 -27 -43 -72 -53 -148 -72 -256 -63 -132 11
        -214 47 -215 93 0 32 -25 22 -45 -19 -24 -45 -15 -74 15 -49 13 11 18 10 33
        -4 10 -9 24 -16 31 -16 6 0 22 -7 35 -15 41 -27 247 -36 312 -14 21 8 61 27
        87 43 40 23 51 26 58 15 6 -11 11 -11 20 -2 9 9 8 21 -4 50 -16 41 -54 62 -44
        24z"
        />
        <path
          d="M1375 1181 c-11 -19 3 -29 55 -40 53 -11 80 -7 80 14 0 8 -19 14 -47
        18 -27 2 -55 8 -64 11 -10 4 -20 3 -24 -3z"
        />
        <path
          d="M587 2686 c-3 -8 0 -18 6 -23 16 -12 117 -16 117 -6 0 11 -75 43 -99
        43 -10 0 -21 -6 -24 -14z"
        />
        <path
          d="M623 2622 c-30 -3 -37 -10 -30 -29 1 -5 16 -8 32 -8 23 0 29 -4 27
        -17 -2 -12 4 -18 16 -18 25 0 48 25 32 35 -6 4 -9 13 -6 20 5 15 -23 22 -71
        17z"
        />
        <path
          d="M456 281 c-19 -30 111 -52 349 -59 247 -7 1126 -7 1370 0 128 4 213
        11 260 22 81 20 93 26 73 37 -8 4 -45 1 -84 -7 -56 -13 -316 -26 -484 -25 -14
        0 -50 0 -80 -1 -30 -1 -120 0 -200 1 -80 0 -154 1 -165 0 -117 -4 -323 -3
        -375 2 -36 3 -69 3 -75 -1 -5 -4 -35 -5 -65 -2 -90 8 -254 8 -272 0 -9 -5 -20
        -4 -23 2 -3 5 -23 10 -44 10 -21 0 -51 4 -67 9 -47 15 -112 22 -118 12z"
        />
        <path
          d="M565 138 c-3 -7 -7 -41 -8 -75 -4 -54 -2 -63 13 -63 14 0 17 11 19
        69 2 64 -12 102 -24 69z"
        />
        <path
          d="M2387 144 c-4 -4 -7 -38 -7 -76 0 -63 2 -68 21 -68 20 0 21 3 14 67
        -7 67 -15 90 -28 77z"
        />
      </g>
    </svg>
  );
}

export default GlowingWaldo;
